import {equals, omit, propEq} from 'ramda';

import {FilterItemType, FilterType} from 'constants/flow/flowTypes';
import {ActiveFiltersType} from 'reducers/category/activeFilters/activeFiltersType';
import {MyFitFiltersType} from '../reducers/myFit';

export type CountFiltersType = Record<
    string,
    {items: Pick<FilterItemType, 'value_id'>[]; code: string}
>;

export const CATEGORIES_WITH_HARDCODED_FILTERS = {
    '/mens-eyeglasses': [4],
    '/womens-eyeglasses': [5],
};

/**
 * Convert My Fit preset filters to the active filters type
 * @param {MyFitFiltersType} filters - My Fit preset MyFitFiltersType
 * @param {FilterType} allFilters - list of the all available filters
 * @param {boolean} isMyFitEnabled - is My Fit enabled
 * @param {ActiveFiltersType} activeFilters - active filters
 * @return {ActiveFiltersType} - converted filters
 */
export const mapFilters = ({
    filters,
    allFilters,
    isMyFitEnabled,
    activeFilters,
}: {
    filters: MyFitFiltersType;
    allFilters: FilterType;
    isMyFitEnabled: boolean;
    activeFilters: ActiveFiltersType;
}) => {
    const myFitFilters = Object.entries(filters)
        .filter(([, ids]) => ids?.length)
        .reduce((acc, [code, ids]) => {
            const filterByCode = allFilters.items.find(propEq('code', code));
            return {
                ...acc,
                [code]: ids?.map(id => filterByCode?.items.find(propEq('value_id', id)) || {}),
            };
        }, {});

    const newFilters = {
        ...omit(Object.keys(filters), activeFilters),
        ...(isMyFitEnabled ? myFitFilters : {}),
    };

    return allFilters.items.reduce((acc, {code}) => ({...acc, [code]: newFilters[code] || []}), {});
};

/**
 * Checks if the My Fit filters are in the current filters
 * @param {MyFitFiltersType} filters - My Fit filters
 * @param {CountFiltersType} countFilters - count filters
 * @return {boolean} - whether countFilters contain th My Fti filters or not
 */
export const isMyFitInFilters = (filters: MyFitFiltersType, countFilters: CountFiltersType) => {
    const countFiltersById = Object.values(countFilters).reduce(
        (acc: Record<string, number[]>, {items, code}) => ({
            ...acc,
            [code]: items?.map(({value_id: id}) => id),
        }),
        {},
    );

    if (equals(CATEGORIES_WITH_HARDCODED_FILTERS[window.location.pathname], filters.gender)) {
        countFiltersById.gender = filters.gender;
    }

    return filters.frame_size?.reduce((acc, id) => {
        return acc || Boolean(countFiltersById.frame_size?.includes(id));
    }, false);
};
